/**
 * Client helpers for ESR preview manual overrides.
 */

export function sectionInstanceKey(section) {
  return section?.instanceId || section?.sectionKey || '';
}

export function mergeSectionOverridesIntoReportData(reportData, overrides) {
  if (!reportData?.sections?.length) return reportData;
  if (!overrides || typeof overrides !== 'object') return reportData;

  return {
    ...reportData,
    sections: reportData.sections.map((section) => {
      const key = sectionInstanceKey(section);
      const patch = overrides[key];
      if (!patch) return section;

      if (section.sectionType === 'data-table' && Array.isArray(patch.rows)) {
        return {
          ...section,
          rows: patch.rows,
          rowCount: patch.rows.length
        };
      }

      if (section.sectionType === 'static') {
        return { ...section, ...patch };
      }

      return section;
    })
  };
}

export function getEffectiveSectionRows(section, overrides) {
  const key = sectionInstanceKey(section);
  const patch = overrides?.[key];
  if (Array.isArray(patch?.rows)) return patch.rows;
  return Array.isArray(section?.rows) ? section.rows : [];
}

export function emptyRowFromColumns(columns = []) {
  const row = {};
  columns.forEach((col) => {
    row[col.key] = '';
  });
  return row;
}
